export default __webpack_public_path__ + "static/bonnie-4e169138be28be50e4cd36610254e5f9.png";